import React, { Component } from 'react';
import {
  Form,
  Message
} from 'semantic-ui-react';
import Can from '../../../abilities/Can';

const FIELDS = {
  "Information": {
    "project_manager": "Project Manager",
    "project_type": "Type",
    "version": "Version"
  },
  "Dates": {
    "start_date": "Start Date",
    "end_date": "End Date",
    "creation_date": "Creation Date",
    "modified_date": "Modified Date"
  },

  "Financial Data": {
    "currency_code": "Currency",
    "tep_order_value_pfe": "Total Revenue",
    "docs_order_value": "DOCS Order Value",
    "offer_value": "Total Offer Value"
  },

  "Product Data": {
    "product": "Product",
    "product_type": "Product type",
    "product_vendor": "Product vendor"
  },

  "Margin": {
    "gross_margin_delta": "Gross Margin Delta",
    "gross_margin": "Progress bar of Gross Margin"
  },

  "Invoices": {
    "invoiced": "Invoiced",
  }
};

class BudgetNextComponentForm extends Component {
  state = {};

  changeColor = (precentage) => {
    var color_bar = "";
    if (precentage >= 70)
      color_bar = "success";
    else if (precentage > 21 && precentage <= 69)
      color_bar = "warning";
    else
      color_bar = "error";
    return color_bar;
  };

  handleCalcPercentage = (item_gross, gross_margin) => {
    const item = Math.round(parseFloat(item_gross.replace('.', '')));
    //console.log(item);
    const percentage = Math.round(100 - ((item * 100) / gross_margin));
    var percentage_gross = percentage + "%";

    return [percentage, percentage_gross];
  };


  render() {

    const { item, state } = this.props;
    // console.log("render ~ item:", item)
    const formFields = FIELDS;
    // console.log("BudgetNextComponentForm ~ render ~ formFields:", formFields)
    // console.log('item:', item)
    // console.log('state:', state)
    // console.log('semaphoreStatus:', this.props.semaphoreStatus)

    return (
      <Form>
        <div>
          <br />
          {Object.keys(formFields).map((key) => {
            if (typeof formFields[key] === "object") {
              const hasNonNullValues = Object.keys(formFields[key]).some(subKey =>
                item.hasOwnProperty(subKey) && item[subKey] !== null
              );
              // console.log("BudgetNextComponentForm ~ {Object.keys ~ hasNonNullValues:", hasNonNullValues)

              return (
                <Form.Group widths='equal' grouped={true} key={key}>
                  <div style={{ marginBottom: '3px' }}>
                    {hasNonNullValues && <label><strong>{key}</strong></label>}
                  </div>

                  <div style={{ display: "flex" }}>
                    {Object.keys(formFields[key]).map(kk => {
                      if (item[kk] !== null) {
                        if (kk !== "gross_margin") {
                          return (
                            <div className='custom-form-field' key={kk} style={{ margin: '1px' }}>
                              <label>{formFields[key][kk]}</label>
                              <div>{item[kk]}</div>
                              <br />
                            </div>
                          );
                        } else {
                          let item_gross = item[kk];
                          if (item_gross !== 0) {
                            return (
                              <div className='custom-form-field' key={kk} style={{ margin: '1px' }}>
                                <label>{'Gross Margin'}</label>
                                <div>{item["gross_margin"]}</div>
                                <br />
                              </div>
                            );
                          } else {
                            return null;
                          }
                        }
                      } else {
                        return null;
                      }
                    })}
                  </div>
                </Form.Group>
              );
            } else if (item[key] !== null) {
              return (
                <div className='custom-form-field' key={key} style={{ margin: '1px' }}>
                  <label>{formFields[key]}</label>
                  <div>{item[key]}</div>
                </div>
              );
            } else if (item[""]) {
              return <></>;
            }
            return null;
          })}
          <div style={{ "width": "100%", "height": "auto", "overflow": "hidden" }}>
            {state && (item.value === "t2") && (item.status === "created" || item.status === "actual" || item.status === "actual pending" || item.status === "saved" || item.status === "cutoff") ?
              <div>
                <Can I="project_planning:Update" a="all">
                  <div style={{ "height": "auto", "overflow": "hidden" }}>
                    {/* <Popup
                      basic content="Update costs and revenues of the open month using actual timereport reported hours/expenses"
                      trigger={
                        <Button
                          content="Update actual"
                          floated='right'
                          icon='check'
                          labelPosition='left'
                          disabled={item.status === 'actual pending'}
                          onClick={this.props.handleUpdate}
                        />
                      }
                    /> */}
                    {/* <Button
                      content="Save"
                      disabled={item.status === 'actual pending'}
                      floated='right'
                      onClick={this.props.handleSave} /> */}
                  </div>
                </Can>
                {item.status === "actual pending" &&
                  <Message floated='right' style={{ "width": "35%", "margin-right": "0", "margin-left": "auto" }}>Your request of Update Actual is being processing.</Message>
                }
              </div>

              : (state && ((item.value === "t1" && item.status === "created") || (item.value === "t0" && item.status === "created"))) ?
                <Can I="project_planning:Update" a="all">
                  {/* TODO remove confrim button */}
                  {/* <div style={{ "height": "auto", "overflow": "hidden" }}>
                    <Popup
                      basic content="Confirm your project Budget planning - no modification to this planning will be allowed"
                      trigger={
                        <Button
                          floated='right'
                          icon='check'
                          color="teal"
                          content="Confirm"
                          disabled={state.confirmDisabled || (this.props.semaphoreStatus === 'running' || this.props.semaphoreStatus === 'completed')}
                          onClick={this.props.handleConfirm}
                        />
                      }
                    />
                  </div> */}
                  {
                    this.props.semaphoreStatus === 'error' ?
                      <Message floated='right' style={{ "width": "40%", "margin-right": "0", "margin-left": "auto" }}>The last execution encountered an error. Please try again.</Message>
                      : this.props.semaphoreStatus === 'running' ?
                        <Message floated='right' style={{ "width": "40%", "margin-right": "0", "margin-left": "auto" }}>The last execution is currently underway. Please wait.</Message>
                        : <></>
                  }
                </Can>
                : ""}
          </div>
        </div>
      </Form>
    );
  }
}
export default BudgetNextComponentForm;
